<div class="restore-backup-confirmation-container">
  <h2 mat-dialog-title>
    {{ 'PAGES.BACKUPS.RESTORE_MODAL.TITLE' | translate }}
    {{ backup.dateTime | date }}?
  </h2>
  <mat-dialog-content>
    @if ((siteEdition$ | async) === 'Premium') {
      @if (isLoadingSubsitesCount$ | async) {
        <glxy-loading-spinner></glxy-loading-spinner>
      } @else {
        <div class="subsite-warning">
          <div>
            <strong>{{ 'PAGES.BACKUPS.RESTORE_MODAL.SUBSITE_WARNING.TITLE' | translate }}</strong>
          </div>
          <div
            [innerHTML]="
              'PAGES.BACKUPS.RESTORE_MODAL.SUBSITE_WARNING.LINE_1' | translate: { count: subsitesCount$ | async }
            "
          ></div>
          <div>{{ 'PAGES.BACKUPS.RESTORE_MODAL.SUBSITE_WARNING.LINE_2' | translate }}</div>
          <ul>
            <li
              [innerHTML]="
                'PAGES.BACKUPS.RESTORE_MODAL.SUBSITE_WARNING.LINE_3' | translate: { count: subsitesCount$ | async }
              "
            ></li>
            <li [innerHTML]="'PAGES.BACKUPS.RESTORE_MODAL.SUBSITE_WARNING.LINE_4' | translate"></li>
          </ul>
          <div>{{ 'PAGES.BACKUPS.RESTORE_MODAL.SUBSITE_WARNING.LINE_5' | translate }}</div>
        </div>
      }
    } @else {
      <div
        [innerHTML]="
          'PAGES.BACKUPS.RESTORE_MODAL.DESCRIPTION'
            | translate: { date: backup.dateTime | date, env: getEnv() | translate }
        "
      ></div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button type="button" mat-button color="accent" (click)="dialogRef.close({ restore: false })">
      {{ 'PAGES.BACKUPS.BUTTONS.CANCEL' | translate }}
    </button>
    @if ((isExpress$ | async) === true) {
      <button
        type="button"
        mat-button
        color="accent"
        (click)="dialogRef.close({ restore: true, toStaging: !isStagingBackup })"
        [disabled]="(subsitesCount$ | async) <= 0 && (siteEdition$ | async) === 'Premium'"
        >
        {{ getSecondaryBtnText() | translate }}
      </button>
    }
    <button
      type="button"
      mat-raised-button
      color="accent"
      (click)="dialogRef.close({ restore: true, toStaging: isStagingBackup })"
      [disabled]="(subsitesCount$ | async) <= 0 && (siteEdition$ | async) === 'Premium'"
      >
      {{ getPrimaryBtnText() | translate }}
    </button>
  </mat-dialog-actions>
</div>
